export function RoleplaySvg({ fillColor = "#FFFFFF", size = 50 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="12.5 12.87 26 23.4"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3665 12.8652C27.3238 12.8652 28.0999 13.6413 28.0999 14.5986V18.0658H23.7666C22.3307 18.0658 21.1666 19.2298 21.1666 20.6658V24.9986H16.3999L12.4999 28.4652V14.5986C12.4999 13.6413 13.2759 12.8652 14.2332 12.8652H26.3665Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6335 20.668C23.6762 20.668 22.9001 21.444 22.9001 22.4013V31.068C22.9001 32.0253 23.6762 32.8013 24.6335 32.8013H35.0335L38.5001 36.268V22.4013C38.5001 21.444 37.7241 20.668 36.7668 20.668H24.6335ZM35.2071 24.2071C35.5976 23.8166 35.5976 23.1834 35.2071 22.7929C34.8166 22.4024 34.1834 22.4024 33.7929 22.7929L29 27.5858L27.2071 25.7929C26.8166 25.4024 26.1834 25.4024 25.7929 25.7929C25.4024 26.1834 25.4024 26.8166 25.7929 27.2071L28.2929 29.7071C28.6834 30.0976 29.3166 30.0976 29.7071 29.7071L35.2071 24.2071Z"
        fill={fillColor}
      />
    </svg>
  );
}
